import React from 'react';

const CellularConnection = (props: { className: any, onClick?: any,style:any }) => {
  const { className, onClick ,style} = props;

  const handleOnClick = (e: any) => {

    if (onClick) onClick(true);
  }

  return (

        <svg width="22" style={style} className={className} height="13" viewBox="0 0 22 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="8" width="4" height="5" rx="1.5" />
        <rect x="6" y="6" width="4" height="7" rx="1.5" />
        <rect x="12" y="3" width="4" height="10" rx="1.5" />
        <rect x="18" width="4" height="13" rx="1.5" />
        </svg>
  );
};
export default CellularConnection;

